export const Currency= {
	BRL : "BRL",
	POINTS : "POINTS",
    MONEY: "MONEY"
}


// WEBPACK FOOTER //
// ./src/const/CurrencyType.js